// DS: PO60
import React, { useState } from 'react';
import { compose } from 'redux';
import { MAX_TITLE_LENGTH, getFolderNameValidationErrorMessage, } from '../../../utils/isValidFolderName';
import { useTranslation } from 'react-i18next';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import withGallections from '../../_hocs/withGallections';
import withCurrentGallectionSubfolders from '../../_hocs/withCurrentGallectionSubfolders';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { createGallection } from '../../actions';
import PremiumForm, { FolderType } from './PremiumForm';
import { getIsOnlyPaidFoldersSelector } from '../../selectors';
import PremiumFolderDisc from '@wix/da-ds/pkg/Icons/PremiumFolderDisc';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ModalDialog from '../../../Popup/ModalDialog';
import ConfirmationPopupFooter from '../../../Popup/BaseConfirmationModal/ConfirmationModalFooter';
import Input from '../../../Input';
import { MediaSourceType } from '../../types';
import { getCoreLevel } from '../../../publicSession/selectors';
import newGallectionPopupStyles from './NewGallectionPopup.scss';
var INITIAL_POINTS_PRICE = 0;
var INITIAL_INPUT_VALUE = '';
var enhance = compose(withCurrentMediaSource, withCurrentGallection, withGallections, withCurrentGallectionSubfolders, connectMediaStore(function (state) { return ({
    onlyNewPaidFolders: getIsOnlyPaidFoldersSelector(state),
    coreLevel: getCoreLevel(state),
}); }, {
    createGallection: createGallection,
}));
export var NewGallectionPopup = function (_a) {
    var currentMediaSource = _a.currentMediaSource, currentFolderId = _a.currentFolderId, subfolders = _a.subfolders, topLevelGallections = _a.gallections, _b = _a.onlyNewPaidFolders, onlyNewPaidFolders = _b === void 0 ? false : _b, coreLevel = _a.coreLevel, onCancel = _a.onCancel, onDone = _a.onDone, createGallectionAction = _a.createGallection;
    var t = useTranslation().t;
    var _c = useState(INITIAL_INPUT_VALUE), inputValue = _c[0], setInputValue = _c[1];
    var _d = useState(onlyNewPaidFolders ? FolderType.PAID : FolderType.REGULAR), folderType = _d[0], setFolderType = _d[1];
    var _e = useState(), premiumFormHasErrors = _e[0], setPremiumFormHasErrors = _e[1];
    var _f = useState(INITIAL_POINTS_PRICE), priceInPoints = _f[0], setPriceInPoints = _f[1];
    var withPremiumForm = currentMediaSource === MediaSourceType.GALLERY &&
        !currentFolderId; /* PF can not be a sub-folder */
    var getValidationErrorIfAny = function (name) {
        var existingNames = (currentFolderId ? subfolders : topLevelGallections).map(function (gallection) { return gallection.name; });
        return getFolderNameValidationErrorMessage(name, t, existingNames, currentMediaSource === MediaSourceType.GALLERY);
    };
    var errorHint = inputValue !== INITIAL_INPUT_VALUE
        ? getValidationErrorIfAny(inputValue)
        : undefined;
    var onSubmit = function () {
        createGallectionAction({
            name: inputValue,
            priceInPoints: priceInPoints,
            folderType: folderType,
        });
        onDone && onDone();
    };
    var newFolderKeyPart = currentFolderId ? 'newSubGallery' : 'new';
    return (React.createElement(ModalDialog, { isOpen: true, rootClassName: newGallectionPopupStyles['root'], headerClassName: newGallectionPopupStyles['header'], titleClassName: newGallectionPopupStyles['title'], contentClassName: newGallectionPopupStyles['content'], footerClassName: newGallectionPopupStyles['footer'], title: React.createElement(React.Fragment, null, onlyNewPaidFolders
            ? t("mediapopup.gallections.premiumFolder.prompt." + newFolderKeyPart + ".title")
            : t("mediapopup.gallections." + currentMediaSource + ".prompt." + newFolderKeyPart + ".title")), headerExtras: withPremiumForm &&
            onlyNewPaidFolders && (React.createElement("div", { className: newGallectionPopupStyles['sub-title'] },
            React.createElement(PremiumFolderDisc, { size: IconSize.TINY, className: newGallectionPopupStyles['sub-title-icon'] }),
            t('mediapopup.newFolderPopup.subtitle.paidFolders'))), footer: React.createElement(ConfirmationPopupFooter, { confirmDisabled: !!errorHint ||
                premiumFormHasErrors ||
                inputValue.length < 1 ||
                (folderType === 'paid' && priceInPoints === INITIAL_POINTS_PRICE), confirmButtonLabel: t('mediapopup.create'), onDone: !errorHint ? onSubmit : undefined, withCancelButton: true, onCancel: onCancel }), onClose: onCancel },
        React.createElement("div", null,
            React.createElement(Input, { autoFocus: true, value: inputValue, label: t("mediapopup.gallections." + currentMediaSource + ".prompt." + newFolderKeyPart + ".label"), errorMessage: errorHint, onChange: setInputValue, onEnter: !errorHint ? onSubmit : undefined, maxLength: MAX_TITLE_LENGTH })),
        withPremiumForm && (React.createElement(PremiumForm, { coreLevel: coreLevel, folderType: folderType, priceInPoints: priceInPoints, onSetError: setPremiumFormHasErrors, onFolderTypeChange: setFolderType, onSetPriceInPoints: setPriceInPoints, onlyNewPaidFolders: onlyNewPaidFolders }))));
};
NewGallectionPopup.displayName = 'NewGallectionPopup';
export default enhance(NewGallectionPopup);
//# sourceMappingURL=NewGallectionPopup.connected.js.map